export enum TagType {
  PACKAGING = "packaging",
  WEB_DESIGN = "web design",
  APP_DESIGN = "app design",
  BRAND_IDENTITY = "brand identity",
  EDITORIAL = "editorial",
  TYPE_DESIGN = "type design",
  ILLUSTRATION = "illustration",
  COPYWRITING = "copywriting",
  PROCESSING = "processing",
  FRONTEND = "frontend",
  BACKEND = "backend",
  REACT = "react",
  FIREBASE = "firebase",
  SEQUELIZE = "sequelize",
  EXPRESS = "express.js",
  DOCUMENTATION = "documentation",
}

const designTags: TagType[] = [
  TagType.PACKAGING,
  TagType.WEB_DESIGN,
  TagType.APP_DESIGN,
  TagType.BRAND_IDENTITY,
  TagType.EDITORIAL,
  TagType.TYPE_DESIGN,
  TagType.ILLUSTRATION,
  TagType.COPYWRITING,
];

const codeTags: TagType[] = [
  TagType.PROCESSING,
  TagType.FRONTEND,
  TagType.BACKEND,
  TagType.REACT,
  TagType.FIREBASE,
  TagType.SEQUELIZE,
  TagType.EXPRESS,
];

const photoTags: TagType[] = [TagType.DOCUMENTATION];

const allTags: TagType[] = [...designTags, ...codeTags, ...photoTags];

export { designTags, codeTags, photoTags, allTags };
